import tinyUrlImage from "./../assests/images/tinyurl.png";
import dishDelight from "./../assests/images/dish-delight.png";
import budgetBuddy from "./../assests/images/budget-buddy.png";
import scoreKeeper from "./../assests/images/score-keeper.png"
import quickTick from './../assests/images/quick-tick.png'
const projectData = [
  {
    title: "Dish Delight",
    image: dishDelight,
    description:
      " for a recipes makes simple and delesious recipes",
    technologies: ["HTML", "CSS", "JavaScript", "React.js"],
    liveDemo: "https://dish-delight-recipe.netlify.app  ",
    github: "https://github.com/SauravShete2003/dish-delight",
    date: "June 2024"
  },
  {
    title: "Budget Buddy",
    image: budgetBuddy,
    description: "for budgeting and expense tracking",
    technologies: [
      "JavaScript",
      "React.js",
      "MongoDB",
      "Node.js",
    ],
    liveDemo: "https://budget-buddy-sooty.vercel.app/",
    github: "https://github.com/SauravShete2003/BudgetBuddy",
    date: "July 2024",
  },
  {
    title: "Tiny URL",
    image: tinyUrlImage,
    description: "A web application for shortening URLs",
    technologies: [
      "JavaScript",
      "React.js",
      "MongoDB",
      "Node.js",
    ],
    liveDemo: "https://tinyshorter.netlify.app",
    github: "https://github.com/SauravShete2003/tinyurl",
    date: "August 2024",
  },

  {
    title: "Score Keeper",
    image: scoreKeeper,
    description: " for keeping track of scores",
    technologies: ["HTML", "CSS", "JavaScript", "React.js"],
    liveDemo: "https://score-keeper-beige.vercel.app/",
    github: "https://github.com/SauravShete2003/score-keeper",
    date: "September 2024",
  },
  {
    title: "Quick Tick",
    image: quickTick,
    description: " creating and managing to-do lists",
    technologies: [
      "JavaScript",
      "React.js",
      "MongoDB",
      "Node.js"
    ],
    liveDemo: "https://quick-tick.netlify.app/",
    github: "https://github.com/SauravShete2003/quick-tick",
    date: "September 2024",
  },
  {
    title: "Taskly",
    image: tinyUrlImage,
    description: "Project Management application for creating and managing tasks",
    technologies: [
      "JavaScript",
      "React.js",
      "MongoDB",
      "Node.js",
    ],
    liveDemo: "https://taskly-1-zj3w.onrender.com/",
    github: "https://github.com/SauravShete2003/Taskly",
    date: "August 2025",
  },
];

export default projectData;
